import { UseDatum } from 'react-usedatum';
import { ArgMap } from '../shared/Types';

export const [useMemberInfo] = UseDatum<ArgMap>({});
export const [usePaymentAmount] = UseDatum<number>(0);
